import { CssBaseline, ThemeProvider } from "@mui/material";
import "./App.css";
import { theme } from "./theme";
import MainRouter from "./Router/MainRouter";
import store from "./redux/stores/store";
import { Provider } from "react-redux";
import { useEffect } from "react";
import { getTenantCustomNameAPI } from "./redux/api/common/CustomDomainApi";
import Cookies from "js-cookie";
import Websocket from "./socket/Websocket";
import DesktopNotificationStack from "./components/admin/DesktopNotificationStack";
import TenantPublishStatusModal from "./components/admin/TenantPublishStatusModal";
import { listenToMessages, requestPermissionAndGetToken } from "./notifications";
import { checkTokenExpiry, getTokenPayload } from "./token/token";
import { saveFcmToken } from "./redux/slices/ecommerce/adminNotifictionSlice";
import NetworkStatusGuard from "./components/NetworkStatusGuard";


function App() {

  const fetchCustomDomain = async () => {
    // debugger
    const hostname = window.location.hostname;
    const res = await getTenantCustomNameAPI(hostname);
    console.log("custom domain response");
    console.log(res)
    console.log(res?.data)
    if (res?.data?.response?.tenantCode)
      Cookies.set("custom_tenant", res?.data?.response?.tenantCode, {
        path: "/",
        domain: hostname,
        // domain: "localhost",
        secure: true,
        sameSite: "Strict",
      });
    window.location.reload();
  };

  useEffect(() => {

    const customTenant = Cookies.get("custom_tenant");
    console.log("custom tenant from cookie:", window.location.hostname);
    if (
      !(
        window.location.hostname.includes("qabranch.d1tx7ryv7rtvh6.amplifyapp.com") ||
        window.location.hostname.includes("padami.app") ||
        window.location.hostname.includes("admin.agavian.in") ||
        customTenant ||
        window.location.hostname.includes("localhost")
      )
    ) {
      fetchCustomDomain();
    }
  }, []);

  useEffect(() => {
    const initNotifications = async () => {
      const hasAuthToken = Boolean(window.sessionStorage.getItem("token"));

      if (!hasAuthToken || checkTokenExpiry()) {
        return;
      }

      const token = await requestPermissionAndGetToken();
      listenToMessages();

      if (token) {
        const state = store.getState();
        const tokenPayload = getTokenPayload("token");
        console.log('state?.companyBrand?.company ', state?.companyBrand?.company)
        const companyId =
          state?.companyBrand?.company?.id ||
          tokenPayload?.companyId ||
          tokenPayload?.company?.id ||
          null;

        store.dispatch(
          saveFcmToken({
            fcmToken: token,
            companyId,
          })
        );
      }
    };

    initNotifications();
  }, []);


  return (
    <div>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Websocket />
          <DesktopNotificationStack />
          <TenantPublishStatusModal />
          <NetworkStatusGuard />
          <CssBaseline />
          <MainRouter></MainRouter>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default App;
